/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AskIndexResponseSource = {
  /**
   * The unique identifier of the source document
   */
  docId: string;
  /**
   * Relevance score for this source (0 to 1000)
   */
  relevanceScore: number;
};

/** @internal */
export const AskIndexResponseSource$inboundSchema: z.ZodType<
  AskIndexResponseSource,
  z.ZodTypeDef,
  unknown
> = z.object({
  doc_id: z.string(),
  relevance_score: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "doc_id": "docId",
    "relevance_score": "relevanceScore",
  });
});

/** @internal */
export type AskIndexResponseSource$Outbound = {
  doc_id: string;
  relevance_score: number;
};

/** @internal */
export const AskIndexResponseSource$outboundSchema: z.ZodType<
  AskIndexResponseSource$Outbound,
  z.ZodTypeDef,
  AskIndexResponseSource
> = z.object({
  docId: z.string(),
  relevanceScore: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    docId: "doc_id",
    relevanceScore: "relevance_score",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AskIndexResponseSource$ {
  /** @deprecated use `AskIndexResponseSource$inboundSchema` instead. */
  export const inboundSchema = AskIndexResponseSource$inboundSchema;
  /** @deprecated use `AskIndexResponseSource$outboundSchema` instead. */
  export const outboundSchema = AskIndexResponseSource$outboundSchema;
  /** @deprecated use `AskIndexResponseSource$Outbound` instead. */
  export type Outbound = AskIndexResponseSource$Outbound;
}

export function askIndexResponseSourceToJSON(
  askIndexResponseSource: AskIndexResponseSource,
): string {
  return JSON.stringify(
    AskIndexResponseSource$outboundSchema.parse(askIndexResponseSource),
  );
}

export function askIndexResponseSourceFromJSON(
  jsonString: string,
): SafeParseResult<AskIndexResponseSource, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AskIndexResponseSource$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AskIndexResponseSource' from JSON`,
  );
}
